import { Component, ViewChild } from '@angular/core';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { Modal } from 'bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-termsdec',
  templateUrl: './termsdec.component.html',
  styleUrls: ['./termsdec.component.scss']
})
export class TermsdecComponent {
  @ViewChild('errorComp') errorComp: ErrorModalComponent;  
   myModal: any;
    trade: any;
    mitc: any;
    pdfModal: any;
  IndianCT: boolean = true;
    MITCTerms: boolean = true;
    NRO: string = '';
    termsStage: boolean = true;
    politically: boolean = true;
    Preferences: boolean = true;
    settled: boolean = true;
    FundSettleDays: string = 'D';
    isMobile: boolean = false;
    autoCredit: string = 'Y';
    Pledge: string = 'N';
    DIS: string = 'Y';
    tDDPI: string = 'Y';
    FirstHold: string = 'Y';
    SecondHold: string = 'N';
    ThreeHold: string = 'N';
    ECS: string = 'Y';
    BSDA: string = 'N';
    tSEBI: string = 'Monthly';
    tRTA: string = 'Y';
    TElectronic: string = 'Physical';

    constructor( private router: Router, private toastr: ToastrService, private loader: NgxUiLoaderService) {

    }
    IndianCTChange(event: Event) {
            this.IndianCT = (event.target as HTMLInputElement).checked;
        }
        MITCTermsChange(event: Event) {
            this.MITCTerms = (event.target as HTMLInputElement).checked;
        }
        politicallyChange(event: Event) {
            this.politically = (event.target as HTMLInputElement).checked;
        }
        PreferencesChange(event: Event) {
            this.Preferences = (event.target as HTMLInputElement).checked;
        }
        settledChange(event: Event) {
            this.settled = (event.target as HTMLInputElement).checked;
        }
        FundSettleDaysChange(event: Event) {
            this.FundSettleDays = (event.target as HTMLInputElement).value;
        }
        NextValidate() {
            if ( !this.MITCTerms  || !this.Preferences ) {
                this.errorComp.ModalShow("Please accept the terms and conditions");
                return;
            } else {
                this.router.navigate(['/aof'], { replaceUrl: true });
            }
        }
        prefer() {
            this.Preferences =true;
            const element = document.getElementById('tradePR') as HTMLElement;
            this.trade = new Modal(element, { backdrop: 'static', keyboard: false });
            this.trade.show();
        }
        MitcTm(){
            this.MITCTerms = true;
             const element = document.getElementById('MitcT') as HTMLElement;
            this.mitc = new Modal(element, { backdrop: 'static', keyboard: false });
            this.mitc.show();
        }
        backStage(){
          this.router.navigate(['/signature'], { replaceUrl: true });
        }
}
